export default __webpack_public_path__ + "static/media/room.7c1091c6.jpg";